"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SourceChannelNameField_1 = __importDefault(require("../SourceChannelNameField/SourceChannelNameField"));
var antd_1 = require("antd");
var LocaleWrapper_1 = require("../../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../../locale/en_US"));
var ContrastEnhancementField_1 = __importDefault(require("../ContrastEnhancementField/ContrastEnhancementField"));
var GammaField_1 = __importDefault(require("../GammaField/GammaField"));
var _get = require('lodash/get');
var _cloneDeep = require('lodash/cloneDeep');
/**
 * ChannelField to select different Channel options
 */
var ChannelField = /** @class */ (function (_super) {
    __extends(ChannelField, _super);
    function ChannelField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updateChannel = function (key, value) {
            var _a = _this.props, onChange = _a.onChange, channel = _a.channel;
            var newChannel;
            if (channel) {
                newChannel = _cloneDeep(channel);
            }
            else {
                newChannel = {};
            }
            newChannel[key] = value;
            if (onChange) {
                onChange(newChannel);
            }
        };
        _this.onSourceChannelNameChange = function (name) {
            _this.updateChannel('sourceChannelName', name);
        };
        _this.onContrastEnhancementChange = function (type) {
            var contrastEnhancement = _get(_this.props, 'channel.contrastEnhancement');
            var newContrastEnhancement;
            if (contrastEnhancement) {
                newContrastEnhancement = _cloneDeep(contrastEnhancement);
            }
            else {
                newContrastEnhancement = {};
            }
            newContrastEnhancement.enhancementType = type;
            _this.updateChannel('contrastEnhancement', newContrastEnhancement);
        };
        _this.onGammaChange = function (gamma) {
            var contrastEnhancement = _get(_this.props, 'channel.contrastEnhancement');
            var newContrastEnhancement;
            if (contrastEnhancement) {
                newContrastEnhancement = _cloneDeep(contrastEnhancement);
            }
            else {
                newContrastEnhancement = {};
            }
            newContrastEnhancement.gammaValue = gamma;
            _this.updateChannel('contrastEnhancement', newContrastEnhancement);
        };
        return _this;
    }
    ChannelField.prototype.render = function () {
        var _a = this.props, sourceChannelNames = _a.sourceChannelNames, channel = _a.channel, contrastEnhancementTypes = _a.contrastEnhancementTypes, locale = _a.locale;
        var sourceChannelName = _get(channel, 'sourceChannelName');
        var contrastEnhancementType = _get(channel, 'contrastEnhancement.enhancementType');
        var gamma = _get(channel, 'contrastEnhancement.gammaValue');
        var formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        };
        return (React.createElement("div", null,
            React.createElement(antd_1.Form.Item, __assign({ label: locale.sourceChannelNameLabel }, formItemLayout),
                React.createElement(SourceChannelNameField_1.default, { onChange: this.onSourceChannelNameChange, sourceChannelName: sourceChannelName, sourceChannelNames: sourceChannelNames })),
            React.createElement(antd_1.Form.Item, __assign({ label: locale.contrastEnhancementTypeLabel }, formItemLayout),
                React.createElement(ContrastEnhancementField_1.default, { contrastEnhancement: contrastEnhancementType, contrastEnhancementOptions: contrastEnhancementTypes, onChange: this.onContrastEnhancementChange })),
            React.createElement(antd_1.Form.Item, __assign({ label: locale.gammaValueLabel }, formItemLayout),
                React.createElement(GammaField_1.default, { gamma: gamma, onChange: this.onGammaChange }))));
    };
    ChannelField.componentName = 'ChannelField';
    ChannelField.defaultProps = {
        locale: en_US_1.default.GsChannelField,
        contrastEnhancementTypes: ['histogram', 'normalize']
    };
    return ChannelField;
}(React.Component));
exports.ChannelField = ChannelField;
exports.default = LocaleWrapper_1.localize(ChannelField, ChannelField.componentName);
//# sourceMappingURL=ChannelField.js.map